/* unplugin-vue-components disabled */import { render } from "./SeesawQuestionSelector.vue?vue&type=template&id=12875b46&scoped=true"
import script from "./SeesawQuestionSelector.vue?vue&type=script&lang=js"
export * from "./SeesawQuestionSelector.vue?vue&type=script&lang=js"

import "./SeesawQuestionSelector.vue?vue&type=style&index=0&id=12875b46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12875b46"]])

export default __exports__